import "./index.scss";
import { Card08Props } from "./types";
import React from "react";
import classNames from "classnames";

const Card08 = ({
  abstract,
  borderTop,
  children,
  image,
  title,
}: Card08Props) => {
  const hasBorderTop = !!borderTop;
  const borderTopCls = classNames("Card08__topbar", {
    [`bg--${borderTop}`]: !!borderTop,
    "Card08_topbar--none": !hasBorderTop,
  });

  const cardCls = classNames("Card08", "box-shadow-card", {
    "box-shadow-card--hasHover": Boolean(children),
  });

  const imageStyle = { backgroundImage: `url(${image})` };

  return (
    <div className={cardCls}>
      <div className={borderTopCls} />
      {image && (
        <div data-testid="card08-image" className="Card08__image-container">
          <div className="Card08__image-background" style={imageStyle} />
        </div>
      )}
      <div className="Card08__wrapper">
        {title && (
          <div data-testid="card08-title" className="Card08__title">
            {title}
          </div>
        )}
        {abstract && (
          <div data-testid="card08-abstract" className="Card08__text">
            {abstract}
          </div>
        )}
        {children && (
          <div
            data-testid="card08-childrenWrapper"
            className="Card08__cta-wrapper"
          >
            {React.Children.map(children, (child) => (
              <div className="Card08__cta-wrapper__item">
                {React.cloneElement(child as React.ReactElement)}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card08;
